import React, { useState } from 'react';
import PersonInputModal from './PersonInputModal'; // Import the new modal component

const ModifyAmount = ({ initialAmount, onSubmit, onCancel, item, image }) => {

  const [amount, setAmount] = useState(initialAmount);
  const [count, setCount] = useState(0);
  const [inputValue, setInputValue] = useState(initialAmount.toString());
  const [showPersonModal, setShowPersonModal] = useState(false);

  const handleDecrease = () => {
    const newAmount = amount - 1;
    setAmount(newAmount);
    setInputValue(newAmount.toString()); // Update inputValue to reflect amount
    setCount(newAmount - initialAmount); // Update count based on difference
  };

  const handleIncrease = () => {
    const newAmount = amount + 1;
    setAmount(newAmount);
    setInputValue(newAmount.toString()); // Update inputValue to reflect amount
    setCount(newAmount - initialAmount); // Update count based on difference
  };

  const handleChangeAmount = (change) => {
    const newAmount = amount + change;
    setAmount(newAmount);
    setInputValue(newAmount.toString()); // Update inputValue to reflect amount
    setCount(newAmount - initialAmount); // Update count based on difference
  };

  const handleSubmit = () => {
    setShowPersonModal(true); // Show the person input modal
  };

  const handlePersonConfirm = (name) => {
    onSubmit(amount, item, name); // Pass the person's name to onSubmit
    setShowPersonModal(false);
  };

  const handlePersonCancel = () => {
    setShowPersonModal(false);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleInputChange = (value) => {
    setInputValue(value); // Update input field with raw value

    // Check if the input contains only valid characters (numbers, +, -, *, /)
    if (/^[\d+\-*/().\s]*$/.test(value)) {
      try {
        // Evaluate the expression safely
        const evaluatedValue = eval(value); // Calculate the value
        if (!isNaN(evaluatedValue)) {
          setAmount(evaluatedValue); // Set the calculated value to amount
          setCount(evaluatedValue - initialAmount); // Update count
        }
      } catch (error) {
        // Handle any errors from eval
        console.error("Väärä syöte: ", error);
      }
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-window modal-window--narrow">
        <h2 className="modal-title">Muuta määrää</h2>
        <div className="modal-content modal-content--center">
          <div className="item-details">
            {item.isOther ? (
              <>
                <p>{item.item}</p>
                <p>{item.info}</p>
              </>
            ) : (
              item.isHandRail ? (
                <>
                  <p>{item.woodType}</p>
                  <p>{item.handRail_woodType} {item.handRailModel}</p>
                  <p>{item.length}mm</p>
                </>
              ) : (
                <>
                  <p>{item.woodType}</p>
                  <p>{item.length}mm x {item.depth}mm</p>
                  <p>{item.thickness}mm</p>
                </>
              )
            )}
          </div>
          <div className={`counter ${count === 0 ? 'counter--zero' : count > 0 ? 'positive' : 'negative'}`}>
            {count > 0 ? `+${count}` : count}
          </div>
          <div className="amount-controls">
            <div className="amount-controls__column">
              <button className="amount-button amount-button--small amount-button--decrease" onClick={() => handleChangeAmount(-5)}>-5</button>
              <button className="amount-button amount-button--small amount-button--decrease" onClick={() => handleChangeAmount(-10)}>-10</button>
            </div>
            <button className="amount-button amount-button--large amount-button--decrease" onClick={handleDecrease}>-1</button>
            <input
              className="amount-input"
              type="text"
              value={inputValue}
              onChange={(e) => handleInputChange(e.target.value)}
            />
            <button className="amount-button amount-button--large amount-button--increase" onClick={handleIncrease}>+1</button>
            <div className="amount-controls__column">
              <button className="amount-button amount-button--small amount-button--increase" onClick={() => handleChangeAmount(5)}>+5</button>
              <button className="amount-button amount-button--small amount-button--increase" onClick={() => handleChangeAmount(10)}>+10</button>
            </div>
          </div>
          <div className="modal-actions modal-actions--center">
            <button className="btn btn-ghost" onClick={handleCancel}>Peru</button>
            <button className="btn btn-primary" onClick={handleSubmit}>Hyväksy</button>
          </div>
        </div>
      </div>
      {showPersonModal && <PersonInputModal item={"Muuta määrää"} onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />}
    </div>
  );
};

export default ModifyAmount;
